import CommentObjectType from './CommentObjectType';
import { COMMENT_ONBOARDING_TOUR_ID, FLOATING_SIDEBAR_TOUR_ID } from './tourIDs';
const floatingSidebarTourBlockList = [CommentObjectType.REPORTING_DASHBOARD, CommentObjectType.WORKFLOW, CommentObjectType.MARKETING_EMAIL];
const onboardingTourBlockListedObjectTypes = {
  [FLOATING_SIDEBAR_TOUR_ID]: floatingSidebarTourBlockList,
  [COMMENT_ONBOARDING_TOUR_ID]: []
};
export default onboardingTourBlockListedObjectTypes;